export default function resolveTimeUnit(seconds) {
  const units = [
    { name: 'year', seconds: 31536000 },
    { name: 'month', seconds: 2592000 },
    { name: 'day', seconds: 86400 },
    { name: 'hour', seconds: 3600 },
    { name: 'minute', seconds: 60 },
    { name: 'second', seconds: 1 }
  ];

  for (const unit of units) {
    const value = seconds / unit.seconds;
    if (value >= 1) {
      const rounded = Math.floor(value);
      return { label: rounded === 1 ? unit.name : `${unit.name}s`, number: rounded };
    }
  }

  return { label: 'flexible', number: 0 }; // fallback for 0 seconds
}
